import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { IconSun, IconMoon } from '../../components/icons';
import NotificationCenter from '../../components/NotificationCenter';

function WorkspaceHeader({
    logoCyrSrc,
    logoError,
    setLogoError,
    setActiveSection,
    setSettingsTab,
    billingSummary,
    orderDynamics,
    orderDynamicsError,
    handleLogout,
    token,
    onNotificationOpen
}) {
    const { theme, toggleTheme } = useTheme();
    const currency = billingSummary?.currency || 'RUB';
    const balance = Number(billingSummary?.balance || 0);
    const dailyCharge = Number(billingSummary?.daily_charge_amount || 0);
    const daysLeft = dailyCharge > 0 ? Math.floor(balance / dailyCharge) : 0;
    const dynamicsAmount = Number(orderDynamics?.yesterday_amount || 0);
    const deltaPercentRaw = orderDynamics?.delta_percent;
    const deltaPercent = deltaPercentRaw === null || deltaPercentRaw === undefined ? null : Number(deltaPercentRaw);
    const deltaSign = deltaPercent !== null && deltaPercent > 0 ? '+' : '';
    const hasNoCabinets = orderDynamics?.has_cabinets === false;
    const notSyncedYet = orderDynamics ? orderDynamics.yesterday_synced === false && !hasNoCabinets : false;
    const balanceFormatter = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    return (
        <div className="workspace__header workspace__header--compact">
            <div className="workspace__brand">
                <button
                    type="button"
                    className="workspace__logo-link"
                    onClick={() => setActiveSection('marketplace')}
                    title="На главную"
                >
                    <div className="hero__logos">
                        {!logoError ? (
                            <img
                                src={logoCyrSrc}
                                alt="Энилекс"
                                className="hero__logo hero__logo--cyr"
                                onError={() => setLogoError(true)}
                            />
                        ) : (
                            <p className="eyebrow">Энилекс.Контроль</p>
                        )}
                    </div>
                </button>
                <div>
                    <div className="workspace__title">Контроль.</div>
                    <div className="workspace__lead">
                        Панель для профессионалов на маркетплейсах.
                    </div>
                </div>
            </div>

            <div className="hero__card hero__card--metrics">
                <div className="metric">
                    <span className="metric__label">Динамика заказов</span>
                    {orderDynamicsError ? (
                        <span className="metric__value metric__down" title="Не удалось загрузить данные">
                            Ошибка загрузки
                        </span>
                    ) : hasNoCabinets ? (
                        <span className="metric__value" title="Нет подключённых кабинетов">
                            Нет данных
                        </span>
                    ) : (
                        <span
                            className="metric__value"
                            title={notSyncedYet ? 'Данные за вчера ещё не синхронизированы' : undefined}
                        >
                            {balanceFormatter.format(dynamicsAmount)} ₽{' '}
                            <span className={deltaPercent !== null && deltaPercent >= 0 ? 'metric__up' : 'metric__down'}>
                                {deltaPercent === null ? '—' : `${deltaSign}${deltaPercent.toFixed(1)}%`}
                            </span>
                            {notSyncedYet && <span className="metric__hint"> обновляется…</span>}
                        </span>
                    )}
                </div>

                <div className="metric metric--balance">
                    <span className="metric__label">Баланс</span>
                    <span className="metric__value">
                        {balanceFormatter.format(balance)} {currency}
                    </span>
                    <span className="metric__hint">Осталось на {Math.max(0, daysLeft)} дн.</span>
                </div>

                <button
                    type="button"
                    className="metric__link"
                    onClick={() => {
                        setActiveSection('settings');
                        setSettingsTab && setSettingsTab('billing');
                    }}
                >
                    Пополнить
                </button>

                <div className="hero__tools">
                    <NotificationCenter token={token} onOpen={onNotificationOpen} />

                    <button
                        type="button"
                        className="theme-toggle"
                        onClick={toggleTheme}
                        title={theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
                    >
                        {theme === 'dark' ? <IconSun /> : <IconMoon />}
                    </button>
                </div>
            </div>

            <button type="button" className="ghost" onClick={handleLogout}>
                Выйти
            </button>
        </div>
    );
}

export default WorkspaceHeader;
